var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOperatingHourIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 -2 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99081 0.833984C4.93081 0.833984 0.833313 4.94065 0.833313 10.0007C0.833313 15.0607 4.93081 19.1673 9.99081 19.1673C15.06 19.1673 19.1666 15.0607 19.1666 10.0007C19.1666 4.94065 15.06 0.833984 9.99081 0.833984ZM9.99998 17.334C5.94831 17.334 2.66665 14.0523 2.66665 10.0007C2.66665 5.94898 5.94831 2.66732 9.99998 2.66732C14.0516 2.66732 17.3333 5.94898 17.3333 10.0007C17.3333 14.0523 14.0516 17.334 9.99998 17.334ZM9.79831 5.41732H9.74331C9.37665 5.41732 9.08331 5.71065 9.08331 6.07732V10.404C9.08331 10.7248 9.24831 11.0273 9.53248 11.1923L13.3366 13.4748C13.6483 13.6582 14.0516 13.5665 14.235 13.2548C14.4275 12.9432 14.3266 12.5307 14.0058 12.3473L10.4583 10.239V6.07732C10.4583 5.71065 10.165 5.41732 9.79831 5.41732Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperatingHourIcon);
export default __webpack_public_path__ + "static/media/operating-hour-icon.89bc751e8672e5d518f4d15b6065f559.svg";
export { ForwardRef as ReactComponent };